import loginReducer from './loginReducer';

export * from './loginActions';
export default loginReducer;
